// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Overlay ── */
.cpd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1300;
  display: flex;
  justify-content: flex-end;
  animation: cpd-fade-in 0.22s ease forwards;
}

@keyframes cpd-fade-in {
  from { background: rgba(0, 0, 0, 0); }
  to   { background: rgba(0, 0, 0, 0.35); }
}

/* ── Drawer panel ── */
.cpd-drawer {
  width: 100%;
  height: 100%;
  margin: 0;
  background: #fff;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.14);
  animation: cpd-slide-in 0.28s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  overflow: hidden;
}

@media (min-width: 768px) {
  .cpd-drawer {
    width: 480px;
  }
}

@keyframes cpd-slide-in {
  from { transform: translateX(120%); opacity: 0.4; }
  to   { transform: translateX(0);    opacity: 1; }
}

/* ── Header ── */
.cpd-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #f3f4f6;
  flex-shrink: 0;
}

.cpd-drawer-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.cpd-close-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #ffffff;
  color: #374151;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

/* .cpd-close-btn:hover {
  background: #e5e7eb;
} */

/* ── Body ── */
.cpd-body {
  flex: 1;
  overflow-y: auto;
  overflow-x: visible;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.cpd-section-label {
  font-size: 11px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.07em;
  margin: 16px 0 12px;
  text-transform: uppercase;
}

.cpd-no-coupons {
  font-size: 14px;
  color: #9ca3af;
  text-align: center;
  margin-top: 32px;
}

.cpd-spinner-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/coupons-popup/coupons-popup.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,+BAA+B,EAAE;AAC1C;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,mEAAmE;EACnE,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,OAAO,2BAA2B,EAAE,YAAY,EAAE;EAClD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;;GAEG;;AAEH,eAAe;AACf;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["/* ── Overlay ── */\n.cpd-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  z-index: 1300;\n  display: flex;\n  justify-content: flex-end;\n  animation: cpd-fade-in 0.22s ease forwards;\n}\n\n@keyframes cpd-fade-in {\n  from { background: rgba(0, 0, 0, 0); }\n  to   { background: rgba(0, 0, 0, 0.35); }\n}\n\n/* ── Drawer panel ── */\n.cpd-drawer {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  background: #fff;\n  border-radius: 0;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -4px 0 32px rgba(0, 0, 0, 0.14);\n  animation: cpd-slide-in 0.28s cubic-bezier(0.4, 0, 0.2, 1) forwards;\n  overflow: hidden;\n}\n\n@media (min-width: 768px) {\n  .cpd-drawer {\n    width: 480px;\n  }\n}\n\n@keyframes cpd-slide-in {\n  from { transform: translateX(120%); opacity: 0.4; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n/* ── Header ── */\n.cpd-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #f3f4f6;\n  flex-shrink: 0;\n}\n\n.cpd-drawer-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.cpd-close-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: none;\n  background: #ffffff;\n  color: #374151;\n  font-size: 13px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n}\n\n/* .cpd-close-btn:hover {\n  background: #e5e7eb;\n} */\n\n/* ── Body ── */\n.cpd-body {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: visible;\n  padding: 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.cpd-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.07em;\n  margin: 16px 0 12px;\n  text-transform: uppercase;\n}\n\n.cpd-no-coupons {\n  font-size: 14px;\n  color: #9ca3af;\n  text-align: center;\n  margin-top: 32px;\n}\n\n.cpd-spinner-wrap {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
